import {Image} from '@yandex-delivery/blocks/image'
import React from 'react'

import {tagToUrl} from '../../lib/tagToUrl'
import type {NavWidgetProps as Props} from '../types'

const NAV_SLUG = 'custom_right_chevron'

export const NavWidget = (_: Props): React.ReactElement => {
  return <Image height={24} src={tagToUrl(NAV_SLUG)} />
}
